import React from "react";
import Achievement from "../achievement";
import Authorv4 from "../authorv4";
import Banner from "../banner";
import Booksv2 from "../booksv2";
import Herov4 from "../herov4";
import Eventv2 from "../eventv2";
import Contactv2 from "../contactv2";
import Header from "../global/header";
import Footer from "../global/footer";

const Version04 = ({ headerv2, footer }) => {
    const { menuv2 } = footer;
    return (
        <>
            <Header header={headerv2} />
            <Herov4 isBg="yes" />
            <Banner />
            <Authorv4 isBg="" />
            <Booksv2 isBg="yes" />
            <Achievement isBg="yes" />
            <Eventv2 isBg="yes" />
            <Contactv2 isBg="" />
            <Footer isBg="yes" menu={menuv2} />
        </>
    );
};
export default Version04;
